<template>
  <ValidationObserver ref="form">
    <form @submit.prevent="submit">
      <dt-modal v-model="isVisible">
        <div slot="header">
          <h4 class="modal-title">
            Email
          </h4>
        </div>
        <div slot="body">
          <contact-summary
            class="mb-4"
            :contact="value"
          />
          <div class="form-control custom-form">
            <dt-select
              v-model="emailType"
              label="Email Type"
              name="emailType"
              :options="lookups['EmailType']"
              validate="required"
            />
            <dt-input
              v-model="emailAddress"
              name="EmailAddress"
              label="Email"
              validate="required"
            />
          </div>
        </div>
        <div slot="footer">
          <button
            type="button"
            class="btn btn-light"
            @click="close()"
          >Cancel</button>
          <button
            type="submit"
            class="btn btn-primary"
            @click="save()"
          >Save</button>
        </div>
      </dt-modal>
    </form>
  </ValidationObserver>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import DtModal from '@/components/utilities/modal/dt-modal.vue'
import DtInput from '@/components/utilities/form/dt-input'
import DtSelect from '@/components/utilities/form/dt-select'
import ContactSummary from '@/components/contacts/forms/contact-summary'
export default {
  name: 'contact-email',
  components: {
    DtModal,
    DtInput,
    DtSelect,
    ContactSummary
  },
  props: {
    value: {
      type: Object
    },
    email: {
      type: Object,
      default() {
        return {
          contact: 0,
          contactEmail: 0,
          emailAddress: '',
          emailType: 0,
          emailTypeName: '',
          primary: ''
        }
      }
    }
  },
  computed: {
    ...mapGetters('lookups', ['lookups']),
    emailType: {
      get() {
        return this.email !== null ? this.email.emailType : 0
      },
      set(value) {
        this.setItem({
          type: 'Email',
          id: this.email.contactEmail,
          property: 'emailType',
          value: parseInt(value)
        })
      }
    },
    emailAddress: {
      get() {
        return this.email !== null ? this.email.emailAddress : ''
      },
      set(value) {
        this.setItem({
          type: 'Email',
          id: this.email.contactEmail,
          property: 'emailAddress',
          value: value
        })
      }
    },
    isVisible: {
      get() {
        return this.value !== null
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    ...mapActions('contacts', ['setItem', 'removeEmail']),
    close() {
      if (this.email.contactEmail === -1) {
        this.removeEmail(-1)
      }
      this.$emit('closing')
    },
    async save() {
      this.$refs.form.validate().then(async success => {
        if (success) {
          this.$emit('send', this.email.contactEmail)
        }
      })
    },
    submit() {}
  }
}
</script>
<style lang="scss" scoped>
.custom-form {
  text-align: left;
  max-height: 200px;
  height: 200px;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/contacts/forms/email.vue